export const downloadSegmentUsersTemplate = (segmentId) => {
  try {
    const headers = "national_id,segment_id,action,user_id,profile_id";
    const rows = [
      `<National ID of the user>,${segmentId},<Add|Remove>,<User identifier: email or platform user id>,<Profile UUID as created in the platform>`,
    ];

    const csvContent = [headers, ...rows].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `segment_users_import_template_${segmentId}_${Date.now()}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (e) {
    void e;
  }
};
